import { render, staticRenderFns } from "./collectCreate.vue?vue&type=template&id=2167a09e&scoped=true"
import script from "./collectCreate.vue?vue&type=script&lang=js"
export * from "./collectCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167a09e",
  null
  
)

export default component.exports